import { render, staticRenderFns } from "./packagename.vue?vue&type=template&id=e8c6a58c&scoped=true&"
import script from "./packagename.vue?vue&type=script&lang=js&"
export * from "./packagename.vue?vue&type=script&lang=js&"
import style0 from "./packagename.vue?vue&type=style&index=0&id=e8c6a58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c6a58c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c6a58c')) {
      api.createRecord('e8c6a58c', component.options)
    } else {
      api.reload('e8c6a58c', component.options)
    }
    module.hot.accept("./packagename.vue?vue&type=template&id=e8c6a58c&scoped=true&", function () {
      api.rerender('e8c6a58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/packagename.vue"
export default component.exports